import { deviationTypesFragment } from 'apollo/fragments/organization';
import { deviationsFragment } from 'apollo/fragments/deviations';
import { gql } from 'graphql.macro';

export const addDeviationTypeTemplate = gql`
    mutation addDeviationType($code: String!, $description: String!, $type: String!) {
        addDeviationType(code: $code, description: $description, type: $type) {
            ...deviationTypesFields
        }
    }
    ${deviationTypesFragment}
`;

export const updateDeviationTypeTemplate = gql`
    mutation updateDeviationType(
        $deviationTypeId: MongoDbObjectId!
        $code: String!
        $description: String!
        $type: String!
    ) {
        updateDeviationType(deviationTypeId: $deviationTypeId, code: $code, description: $description, type: $type) {
            ...deviationTypesFields
        }
    }
    ${deviationTypesFragment}
`;

export const deleteDeviationTypeTemplate = gql`
    mutation deleteDeviationType($deviationTypeId: MongoDbObjectId!) {
        deleteDeviationType(deviationTypeId: $deviationTypeId) {
            ...deviationTypesFields
        }
    }
    ${deviationTypesFragment}
`;

export const addDeviationTemplate = gql`
    mutation addDeviation($orderDeviation: OrderDeviation!) {
        addDeviation(orderDeviation: $orderDeviation) {
            ...deviationsFields
        }
    }
    ${deviationsFragment}
`;

export const updateDeviationTemplate = gql`
    mutation updateDeviation($orderDeviation: OrderDeviation!) {
        updateDeviation(orderDeviation: $orderDeviation) {
            ...deviationsFields
        }
    }
    ${deviationsFragment}
`;

export const deleteDeviationTemplate = gql`
    mutation deleteDeviation($orderId: MongoDbObjectId!, $deviationId: MongoDbObjectId!) {
        deleteDeviation(orderId: $orderId, deviationId: $deviationId)
    }
`;

export const addDeviationActionTemplate = gql`
    mutation addDeviationAction($orderDeviationAction: OrderDeviationAction!) {
        addDeviationAction(orderDeviationAction: $orderDeviationAction) {
            ...deviationsFields
        }
    }
    ${deviationsFragment}
`;

export const updateDeviationActionTemplate = gql`
    mutation updateDeviationAction($orderDeviationAction: OrderDeviationAction!) {
        updateDeviationAction(orderDeviationAction: $orderDeviationAction) {
            ...deviationsFields
        }
    }
    ${deviationsFragment}
`;

export const deleteDeviationActionTemplate = gql`
    mutation deleteDeviationAction(
        $orderId: MongoDbObjectId!
        $deviationId: MongoDbObjectId!
        $actionId: MongoDbObjectId!
    ) {
        deleteDeviationAction(orderId: $orderId, deviationId: $deviationId, actionId: $actionId) {
            ...deviationsFields
        }
    }
    ${deviationsFragment}
`;
